import forge from 'node-forge';

// RSA encryption config
const RSA_CONFIG = {
  modulus:
    '009c7b3ba621a26c4b02f48cfc07ef6ee0aed8e12b4bd11c5cc0abf80d5206be69e1891e60fc88e2d565e2fabe4d0cf630e318a6c721c3ded718d0c530cdf050387ad0a30a336899bbda877d0ec7c7c3ffe693988bfae0ffbab71b25468c7814924f022cb5fda36e0d2c30a7161fa1c6fb5fbd7d05adbef7e68d48f8b6c5f511827c4b1c5ed15b6f20555affc4d0857ef7ab2b5c18ba22bea5d3a79bd1834badb5878d8c7a4b19da20c1f62340b1f7fbf01d2f2e97c9714a9df376ac0ea58072b2b77aeb7872b54a89667519de44d0fc73540beeaec4cb778a45eebfbefe2d817a8a8319b2bc6d9fa714f5289ec7c0dbc43496d71cf2a642cb679b0fc4072fd2cf',
  publicExponent: '010001',
};

const toHex = (str: string): string => {
  let hex = '';
  for (let i = 0; i < str.length; i++) {
    hex += str.charCodeAt(i).toString(16);
  }
  return hex;
};

export interface AuthDataParams {
  version: string;
  pan: string;
  pin: string;
  expiryDate: string;
  cvv: string;
}

export const generateAuthData = async ({
  version,
  pan,
  pin,
  expiryDate,
  cvv,
}: AuthDataParams): Promise<string> => {
  try {
    const authDataCipher = `${version}Z${pan}Z${pin}Z${expiryDate}Z${cvv}`;
    const authDataBytes = forge.util.hexToBytes(toHex(authDataCipher));

    const rsa = forge.pki.rsa;
    const modulos = new forge.jsbn.BigInteger(RSA_CONFIG.modulus, 16);
    const exp = new forge.jsbn.BigInteger(RSA_CONFIG.publicExponent, 16);
    const publicKey = rsa.setPublicKey(modulos, exp);

    const clearSecureBytes = forge.util.createBuffer();
    clearSecureBytes.putBytes(authDataBytes);

    const encryptedBytes = publicKey.encrypt(clearSecureBytes.getBytes());
    return forge.util.encode64(encryptedBytes);
  } catch (error) {
    throw new Error('Failed to encrypt card data');
  }
};

export const formatExpiryForApi = (expiry: string): string => {
  const cleaned = expiry.replace(/\s|\//g, '');
  if (cleaned.length !== 4) return '';
  const month = cleaned.substring(0, 2);
  const year = cleaned.substring(2, 4);
  return `${year}${month}`;
};

export const cleanPan = (pan: string): string => {
  return pan.replace(/\s/g, '');
};
